import { envChangeType } from "../../plugins/utils";
import Slogan from "./components/Slogan";
import styles from "./style.module.scss";
import "./style.scss";

const TopArea = ({ data, showButton }) => {
  // const [bgImage, setBgImage] = useState([topBg]);
  // let index = 1;

  // useEffect(() => {
  //   if (!data || data?.slide.length < 0) return;

  //   setBgImage(data?.slide[0].slideimage);

  //   const changeImage = setInterval(() => {
  //     if (data?.slide.length > 1) {
  //       setBgImage(data?.slide[index % data?.slide.length].slideimage);
  //       index++;
  //     }
  //   }, 5000);

  //   return () => clearInterval(changeImage); // Cleanup on unmount
  // }, [data]);

  return (
    <div
      className={styles.topArea}
      style={{
        backgroundImage: `url('/images/home/${envChangeType(
          "REACT_APP_PRODUCTION_NAME_DEV",
        )}/top-bg.jpg')`,
      }}
    >
      <div id="stars" />
      <div id="stars2" />
      <div id="stars3" />
      <div className={styles.left}>
        <Slogan showButton={showButton} />
      </div>
      {/* <video
        className={styles.video}
        autoPlay="autoplay"
        loop="loop"
        muted="muted"
        // webkit-playsinline="true"
        // playsInline={true}
      >
        <source src={video} type="video/mp4" />
      </video> */}
    </div>
  );
};

export default TopArea;
